import { useEffect } from "react";
import { createUseStyles } from "react-jss";
import Label from "../../refresh/Label";
import { useMediaSelector } from "../../refresh/selectors/MediaSelector";
import styles from "../types/sharedStyles";

const useStyles = createUseStyles({ ...styles });

const DocumentElement = ({ value, onChange }) => {
  const [media, getMedia] = useMediaSelector(value.document ?? {});
  const classes = useStyles();

  useEffect(() => {
    if (media.id) {
      onChange({
        document: {
          id: media.id,
          name: media.title ?? media.name,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media.id]);

  return (
    <>
      <Label name="Document" required>
        <div className={classes.genericSelector}>
          <div
            style={{
              backgroundImage: `url("${window.location.origin}/tour/assets/hotspots/pdf.png")`,
            }}
          />
          <p>{value.document?.name ?? "Select a document"}</p>
          <button onClick={() => getMedia([4])}>Select from CMS</button>
        </div>
      </Label>
    </>
  );
};

export default DocumentElement;
